import { useAppStore } from "@/components/AppHooks";
import { TCocktailDetailTanquerayProps } from "../type";
import { SingleImg } from "@/components/shared/SingleImg";
import { CraftingContainer } from "./crafting-container";
import { CraftingSetpContainer } from "./crafting-setp-container";
import { TanquerayCocktailList } from "@/components/shared/Tanqueray/TanqueryCocktailList";
import { TCocktail } from "@/shared/types";
import { useEffect, useState } from "react";
import { getCocktailInfo, GetLocale, getUrlQuery, UtilPrevBack } from "@/shared/utils";
import { tracking } from "@/shared/tracking";
import { TanquerayBack } from "@/components/shared/Tanqueray/TanquerayBack";
import { useRouter, useSearchParams } from "next/navigation";
import AppLoader from "@/components/AppLoader";

export function CocktailDetailsTanqueray(props: TCocktailDetailTanquerayProps) {
    const noResult = props.searchParams.noResult === 'true'
    // const cocktailInfo = storeConfig?.cocktailList.find((item) => item.cocktailID.id.toLowerCase() === cocktailId?.toLowerCase())?.cocktailID!
    const { results } = useAppStore()
    const [cocktailInfo, setCocktailInfo] = useState<TCocktail>()
    const [loading, setLoading] = useState(true)
    // const [cocktailId, setCocktailId] = useState<string>('')
    // useEffect(() => {
    //     const _cocktailId = getUrlQuery('cocktailId')
    //     if (!_cocktailId) {
    //         window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${_cocktailId}`)
    //         return
    //     }
    //     setCocktailId(_cocktailId)
    //     tracking({
    //         "event": "pageView",
    //         "pagePath": location.pathname + location.search,
    //         "gatewayVersion": "v5"
    //     })
    //     getCocktailInfo([_cocktailId]).then((cocktail) => {
    //         if (cocktail.length === 0) {
    //             window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${_cocktailId}`)
    //             return
    //         }
    //         setCocktailInfo(cocktail[0])
    //         setLoading(false)
    //         tracking({
    //             "event": "custom_event",
    //             "event_name": "view_recipe",
    //             "recipe_id": _cocktailId,
    //             "recipe_name": cocktail[0].cocktailTitle,
    //             "brand": cocktail[0].brandName
    //         })
    //     })

    // }, [])
    const searchParams = useSearchParams()
    const cocktailId = searchParams?.get('cocktailId')
    useEffect(() => {
        if (!cocktailId) {
            window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${cocktailId}`)
            return
        }
        tracking({
            "event": "pageView",
            "pagePath": location.pathname + location.search,
            "gatewayVersion": "v5"
        })
        getCocktailInfo([cocktailId]).then((cocktail) => {
            if (cocktail.length === 0) {
                window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${cocktailId}`)
                return
            }
            setCocktailInfo(cocktail[0])
            setLoading(false)
            tracking({
                "event": "custom_event",
                "event_name": "view_recipe",
                "recipe_id": cocktailId,
                "recipe_name": cocktail[0].cocktailTitle,
                "brand": cocktail[0].brandName
            })
        })
    }, [cocktailId])
    const router = useRouter()
    return <div className="page-tanqueray-cocktail-details">
        {
            cocktailInfo && <>
                {cocktailInfo?.recipeFirstImage?.url &&
                    <div className="cocktail-hero-wrapper">
                        <SingleImg image={cocktailInfo.recipeFirstImage} />
                    </div>
                }
                <div className="tanqueray-grid">
                    <TanquerayBack onClick={() => {
                        UtilPrevBack().then((res) => {
                            if (res) {
                                const params = new URLSearchParams(location.search);
                                params.delete('cocktailId');
                                params.delete('noResult');
                                const query = params.toString();
                                router.replace(`/${GetLocale()}/results${query ? '?' + query : ''}`)
                            }
                        })
                    }} />
                    <h1 className="cocktail-info-title">{cocktailInfo?.cocktailTitle || ''}</h1>
                    <div className="cocktail-info-desc" dangerouslySetInnerHTML={{ __html: cocktailInfo?.cocktailDescriptionBig || '' }}></div>
                    <CraftingContainer key={cocktailId} {...props} cocktainInfo={cocktailInfo} />
                    <CraftingSetpContainer {...props} cocktainInfo={cocktailInfo} />
                    {
                        results && !noResult && <div className="more-cocktail-containe">
                            <div className="title">{props.titleSimilarCocktails}</div>
                            {
                                results && results?.cocktailRecommendations.length > 0 && <TanquerayCocktailList cocktailList={results?.cocktailRecommendations.filter((item) => item.cocktailId !== cocktailId).slice(0, 3)} cta={props.cTANameSimilarCocktails} matchText={props.matchTextSimilarCocktails} />
                            }
                        </div>
                    }

                </div>
            </>
        }
        {
            loading && <AppLoader />
        }
    </div>
}